<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <h2>Pagamento em Processamento</h2>
                <h4>São listados pagamentos de comissões de agencimaneto/corretagem em processamento.</h4>
            </v-flex>
            <v-flex md12>
                <br>
                <div class="line"></div>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="comissoes"
                    :items-per-page="topItems"
                    :loading="loading"
                    loading-text="Carregando... Por favor aguarde."
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"  
                    :sort-by="['numeroRecibo']"
                    :sort-desc="[true]"                         
                    class="">

                    <template v-slot:item.tipoComissao="{ item }">
                        {{ tipoComissao(item.tipoComissao) }}
                    </template>

                    <template v-slot:item.formaPagamento="{ item }">
                        {{ formaPagamento(item.formaPagamento) }}
                    </template>

                    <template v-slot:item.valorBruto="{ item }">
                        {{ formatPrice(item.valorBruto - (item.valorInss+item.valorIss+item.impostoRendaRetido)) }}
                    </template>

                    <template v-slot:item.excel="{ item }">
                        <img class="hover" v-if="item.tipoSistema.toUpperCase() != 'I4PRO'" src="/img/icon-xls.png" @click="gerarExcel(item)" />
                        <span v-if="item.tipoSistema.toUpperCase() == 'I4PRO'">--</span>
                    </template>
                    <template v-slot:item.pdf="{ item }">
                        <img class="hover" src="/img/icon-pdf.png" @click="gerarPDF(item)" />
                    </template>
                </v-data-table>
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-layout>
    </v-flex>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                termoPesquisa: "",
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 100,
                offset: 1,
                options: {},
                headers: [
                    {text: "Recibo", value: "numeroRecibo", sortable: true},
                    {text: "Tipo", value: "tipoComissao", sortable: true},
                    // {text: "Data", value: "dataPagamento", sortable: true},
                    {text: "Forma de Pagamento", value: "formaPagamento", sortable: true},
                    {text: "Valor Líquido (R$)", value: "valorBruto", sortable: true},
                    {text: "Download (Excel)", value: "excel", sortable: false},
                    {text: "Download (PDF)", value: "pdf", sortable: false}
                ],
                comissoes: []
            }
        },        
        methods: {
            requestComissoes(){
                this.loading = true;
                this.fullLoading = true;

                let top = this.topItems;
                let skip = (this.offset * top) - top;
                let codigoCorretor = this.usuario.codCorretor;                

                let url = "ResumoPagamentoComissao/Processando/"+codigoCorretor+"?$top="+top+"&$skip="+skip;
                 
                 // Se tiver termo para pesquisa
                if(this.termoPesquisa != "")
                    url += "&$filter=numeroRecibo eq " + this.termoPesquisa;
                    //console.log(url)


                // Request comissoes
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.comissoes = res.data;
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });        
            },
            pesquisar(){
                this.offset = 1
                this.requestComissoes()
            },
            gerarExcel(value){
                let numeroRecibo = value.numeroRecibo;
                let url = this.baseURL + "Emissao/ReciboComissaoExcel/"+numeroRecibo;
                window.open(url, "_blank");
            },
            gerarPDF(value){
                let numeroRecibo = value.numeroRecibo;
                let url = this.baseURL + "Emissao/ReciboComissaoPdf/"+numeroRecibo;
                if (value.tipoSistema.toUpperCase() ==  'I4PRO')
                {
                    url = value.linkReciboComissao;
                } 

                window.open(url, "_blank");
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            tipoComissao(value){
                if(value == "COR")
                    return "Corretagem";
                if(value == "PRO")
                    return "Pró-Labore";
                if(value == "AGE")
                    return "Agenciamento";

                return value;
            },
            formaPagamento(value){
                if(value == "CRE")
                    return "CRÉDITO EM C.C.";

                return value;
            }
        },
        watch: {
            options(value){
                if(this.offset != value.page)
                {
                    this.offset = value.page
                    this.topItems = value.itemsPerPage
                    this.requestComissoes()
                }
            }
        },        
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){            
            this.requestComissoes()
        },
    }
</script>
